import { ApmRoute } from '@elastic/apm-rum-react';
import { OPEN_SUBMISSION_DOCUMENTS_OVERVIEW } from '@interhyp/api-credit';
import { OPEN_LOAN_PARTNER_COMMUNICATION_OVERVIEW } from '@interhyp/api-credit-communication';
import { Toaster } from '@platform/elements';
import React, { useEffect, useState } from 'react';
import { Redirect, Switch, useHistory } from 'react-router-dom';

import styles from '../../../Application.module.scss';
import { COMMUNICATION_PLUGIN_ENABLED } from '../../../constants/env';
import { useFrontendNotifications } from '../../../hooks/useFrontendNotifications';
import { Footer } from '@interhyp/platform-navigation';
import { SubmissionCommunicationOverviewLegacyWrapper } from '../../viewWrappers/submission/SubmissionCommunicationOverviewLegacyWrapper';
import { SubmissionDocumentsLegacyWrapper } from '../../viewWrappers/submission/SubmissionDocumentsLegacyWrapper';
import { SubmissionOverviewLegacyWrapper } from '../../viewWrappers/submission/SubmissionOverviewLegacyWrapper';

import '@platform/elements/esm/index.css';
import '@interhyp/platform-navigation/esm/index.css';

export interface LegacyAppProps {}

function useQuery() {
  return new URL(window.location.href);
}

function transformUserIdToUserUUID(userId: string): string {
  const prefix = '22b4cd63-fcb3-04c5-8e86-6964';
  const encodedId = Number.parseInt(userId, 10).toString(16).padStart(8, '0');
  return prefix + encodedId;
}

export default function LegacyApp({}: LegacyAppProps): JSX.Element {
  const query = useQuery();
  const { push } = useHistory();

  const [ehypData, setEhypData] = useState({
    submissionId: query.searchParams.get('sbmId'),
    caseId: query.searchParams.get('caseId'),
    providerId: query.searchParams.get('prvId'),
    currentUserId: query.searchParams.get('userId'),
  });

  useEffect(() => {
    const ehypData = {
      submissionId: query.searchParams.get('sbmId'),
      caseId: query.searchParams.get('caseId'),
      providerId: query.searchParams.get('prvId'),
      currentUserId: transformUserIdToUserUUID(query.searchParams.get('userId')),
    };
    setEhypData(ehypData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  OPEN_SUBMISSION_DOCUMENTS_OVERVIEW.useEvent(() => push(`/credit/documents`));

  OPEN_LOAN_PARTNER_COMMUNICATION_OVERVIEW.useEvent(event => {
    if (event.payload.resourceType === 'SUBMISSION' && COMMUNICATION_PLUGIN_ENABLED) {
      push(`/credit/communication`);
    }
  }, []);

  useFrontendNotifications();
  return (
    <div className={styles.viewport}>
      <Toaster />
      <div className={styles.content}>
        <Switch>
          <ApmRoute path="/credit/" exact component={() => <Redirect to="/credit/summary" />} />
          <ApmRoute
            path="/credit/summary"
            component={() => (
              <SubmissionOverviewLegacyWrapper
                caseId={ehypData.caseId}
                submissionId={ehypData.submissionId}
                providerId={ehypData.providerId}
                currentUserId={ehypData.currentUserId}
              />
            )}
          />
          <ApmRoute
            path="/credit/documents"
            component={() => (
              <SubmissionDocumentsLegacyWrapper
                submissionId={ehypData.submissionId}
                providerId={ehypData.providerId}
              />
            )}
          />
          {COMMUNICATION_PLUGIN_ENABLED && (
            <ApmRoute
              path="/credit/communication"
              component={() => (
                <SubmissionCommunicationOverviewLegacyWrapper
                  submissionId={ehypData.submissionId}
                />
              )}
            />
          )}
        </Switch>
      </div>
      <Footer
        copyrightInfo={{ companyName: 'Interhyp AG' }}
        description={
          'Baufinanzierung beim Testsieger in der Kategorie "Vermittler" (Euro 08/2023): online berechnen, informieren, persönliche Beratung zur optimalen Baufinanzierung und Modernisierungsfinanzierung'
        }
        configurableLinks={[
          { label: 'Datenschutz', href: 'https://interhyp.de/datenschutz' },
          { label: 'Impressum', href: 'https://interhyp.de/impressum' },
        ]}
      />
    </div>
  );
}
